import {v4 as uuidv4} from 'uuid';

export const createTile = (value = 2) => ({
  id: uuidv4(),
  value,
  isNew: true,
  isMerged: false,
});

export const getEmptyCells = (grid) => {
  const cells = [];
  for (let r = 0; r < 4; r++) {
    for (let c = 0; c < 4; c++) {
      if (!grid[r][c]) cells.push({r, c});
    }
  }
  return cells;
};

export const addRandomTile = (grid, forcedValue = null) => {
  const emptyCells = getEmptyCells(grid);
  if (emptyCells.length === 0) return grid;

  const {r, c} = emptyCells[Math.floor(Math.random() * emptyCells.length)];
  const newGrid = grid.map(row => [...row]);
  const value = forcedValue || (Math.random() < 0.9 ? 2 : 4);
  newGrid[r][c] = createTile(value);
  return newGrid;
};

export const initializeGame = () => {
  let grid = Array(4).fill(null).map(() => Array(4).fill(null));
  grid = addRandomTile(grid, 2);
  grid = addRandomTile(grid, 2);
  return grid;
};

const moveLine = (line) => {
  let newLine = line.filter(tile => tile !== null);
  let score = 0;
  let merges = 0;

  for (let i = 0; i < newLine.length - 1; i++) {
    if (newLine[i].value === newLine[i + 1].value) {
      const mergedValue = newLine[i].value * 2;
      const mergedTile = {
        ...createTile(mergedValue),
        id: uuidv4(),
        isMerged: true,
      };
      score += mergedValue;
      merges++;
      newLine[i] = mergedTile;
      newLine.splice(i + 1, 1);
    }
  }

  while (newLine.length < 4) {
    newLine.push(null);
  }

  return {line: newLine, score, merges};
};

export const moveGrid = (grid, direction) => {
  let workingGrid = grid.map(row => [...row]);
  let totalScore = 0;
  let totalMerges = 0;
  let moved = false;

  const rotateLeft = (g) => {
    const res = Array(4).fill(null).map(() => Array(4).fill(null));
    for (let r = 0; r < 4; r++) {
      for (let c = 0; c < 4; c++) {
        res[3 - c][r] = g[r][c];
      }
    }
    return res;
  };

  const rotateRight = (g) => rotateLeft(rotateLeft(rotateLeft(g)));
  const rotate180 = (g) => rotateLeft(rotateLeft(g));

  if (direction === 'right') workingGrid = rotate180(workingGrid);
  if (direction === 'up') workingGrid = rotateLeft(workingGrid);
  if (direction === 'down') workingGrid = rotateRight(workingGrid);

  for (let r = 0; r < 4; r++) {
    const result = moveLine(workingGrid[r]);
    workingGrid[r] = result.line;
    totalScore += result.score;
    totalMerges += result.merges;
  }

  if (direction === 'right') workingGrid = rotate180(workingGrid);
  if (direction === 'up') workingGrid = rotateRight(workingGrid);
  if (direction === 'down') workingGrid = rotateLeft(workingGrid);

  if (JSON.stringify(grid) !== JSON.stringify(workingGrid)) {
    moved = true;
  }

  return {
    grid: workingGrid,
    score: totalScore,
    merges: totalMerges,
    moved
  };
};

export const checkGameOver = (grid) => {
  if (getEmptyCells(grid).length > 0) return false;

  for (let r = 0; r < 4; r++) {
    for (let c = 0; c < 4; c++) {
      const val = grid[r][c].value;
      if (c < 3 && grid[r][c + 1] && grid[r][c + 1].value === val) return false;
      if (r < 3 && grid[r + 1][c] && grid[r + 1][c].value === val) return false;
    }
  }

  return true;
};